import Modules from '@app/modules';
Modules.register({
    namespace: 'RF/Scout24',
    blocks: {
        Products: function () { return import(/* webpackChunkName: "Ecommerce-Products" */ '@app/modules/Woodrangers/Ecommerce/Blocks/Products.vue'); },
        References: function () { return import(/* webpackChunkName: "Ecommerce-References" */ '@app/modules/Woodrangers/Ecommerce/Blocks/References.vue'); },
    },
    routes: []
});
